import { linksSlice } from './slice';

const Actions = linksSlice.actions;
const Reducer = linksSlice.reducer;

export { Reducer, Actions };
